"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mutateCgpProgram(original, num_in, num_mid, num_out) {
    const programData = original.split(" ");
    const ops = ["+", "-", "*"];
    for (let i = 0; i < num_mid; i++) {
        const idx = i + num_in;
        const dataIdx = i * 3;
        if (Math.random() < 0.02) {
            // Pick a number < idx for left:
            const left = Math.floor(Math.random() * idx);
            const right = Math.floor(Math.random() * idx);
            const opIdx = Math.floor(Math.random() * ops.length);
            const op = ops[opIdx];
            programData[dataIdx] = left.toString();
            programData[dataIdx + 1] = right.toString();
            programData[dataIdx + 2] = op;
        }
    }
    // TODO: Put on the outputs:
    for (let i2 = 0; i2 < num_out; i2++) {
        if (Math.random() < 0.02) {
            const dataIdx = num_mid * 3 + i2;
            const idxMax = num_in + num_mid;
            const idx = Math.floor(Math.random() * idxMax);
            programData[dataIdx] = idx.toString();
        }
    }
    return programData.join(" ");
}
exports.default = mutateCgpProgram;
